module.exports = {
	baseurl: "https://suncharapi.aquil.net"
} 